export const TAB_NAMES = {
  Products: 'products',
  Presentation: 'overview',
  Documents: 'documents',
  Software: 'software-and-firmware',
  SoftwareRegistration: 'software-registration',
  WebinarAndResources: 'webinar-and-resources',
};

export const GLOBAL_ANALYTICS_EVENT_NAME = 'track_analytics';
export const GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME = 'update_page_load';
export const FILTER_STATE_CHANGED_EVENT_NAME = 'refinementStateChanged';

export const pageLoadDataParams = {
  DIGITAL_PLATFORM: 'digitalPlatform',
  DIGITAL_PLATFORM_COUNTRY: 'digitalPlatformCountry',
  ENVIRONMENT: 'environment',
};

export const events = {
  VIRTUAL_PAGE_VIEW: 'virtualPageview',
  PRODUCT_VIEW: 'eeListClick',
  DOWNLOAD_DOCUMENT: 'downloadDocument',
  ADD_TO_CART: 'addToCart',
  DOWNLOAD: 'download',
  REMOVE_FROM_CART: 'removeFromCart',
  FILTER_CLICK: 'filterClick',
  COMPARATOR: 'comparator',
  SEARCH: 'search',
  VIDEO_START: 'video_start',
  VIDEO_COMPLETE: 'video_complete',
  CLICK_EXTERNAL_PARTNER_LINK: 'click_external_partner_link',
  VIEW_EXTERNAL_PARTNER_LINK: 'view_external_partner_link',
  VIEW_ITEM: 'view_item',
  EXIT_TO_SCHNEIDER: 'exit_to_schneider',
  CS_EXIT_TO_SCHNEIDER: 'exit_to_schneider',
  SELECT_ITEM_CTA: 'select_item',
  VIEW_ITEM_LIST: 'view_item_list',
  CTA_CLICK: 'cta_click',
  PAGE_VIEW: 'page_view',
} as const;

export const EXTERNAL_PARTNER_NAME = 'Spare-Place';

export const virtualPagesTypes = {
  PAGINATION: 'pagination',
  MODAL_WINDOW: 'modalWindow',
  TABS_ON_RANGE: 'tabsOnRange',
} as const;

export const virtualPagesNames = {
  PRODUCT_SELECTOR: 'productSelector',
  BUY_ONLINE: 'buyOnline',
  BUY_ONLINE_CIRCULAR: 'buyOnlineCircular',
  RELATED_PRODUCTS: 'relatedProducts',
  DOWNLOAD_INSTALLATION_FILE: 'downloadInstallationFile',
  HELP_ME_CHOOSE: 'helpMeChoose',
  DOWNLOAD: 'download',
  SEE_SOFTWARE: 'seeSoftware',
  SEE_CONFIGURATOR: 'seeConfigurator',
  MEDIA_GALLERY: 'mediaGallery',
  CROSS_SALE_PRODUCTS: 'crossSaleProducts',
  UP_SALE_PRODUCTS: 'upSaleProducts',
  RELATED_SOFTWARE: 'relatedSoftware',
  RELATED_LIFECYCLE_SERVICES: 'relatedLifecycleServices',
  FILTERS: 'filters',
  MAIN_DOCUMENTS: 'mainDocuments',
} as const;

export const refinementStateChangedActionNames = {
  FILTER_SELECTED: 'Filter selected',
  FILTER_DESELECTED: 'Filter deselected',
} as const;

export const virtualPagesNestedLocations = {
  HELP_ME_CHOOSE: 'helpMeChoose',
} as const;

export const addCartLocation = {
  CTA_BAR: 'ctaBar',
  PRODUCT_SELECTOR: 'productSelector',
  PRODUCT_MAIN: 'productMain',
  STICKY_BAR: 'stickyBar',
} as const;

export const addCartCTAType = {
  BUTTON_GROUP_OF_PRODUCTS: 'buttonGroupOfProducts',
  BUTTON_SINGLE_PRODUCT: 'buttonSingleProduct',
  QUANTITY_CONTROL: 'quantityControl',
} as const;

export const productLists = {
  COMPARED_PRODUCTS: 'comparedProducts',
  GRID_VIEW_PRODUCTS: 'gridViewProducts',
  LIST_VIEW_PRODUCTS: 'listViewProducts',
  MY_PRODUCTS: 'myProducts',
  OTHER_PRODUCTS_FROM_SERIES: 'otherProductsFromSeries',
  RECENTLY_VIEWED_PRODUCTS: 'recentlyViewedProducts',
  RELATED_PRODUCTS: 'relatedProducts',
  RELATED_PRODUCTS_MODAL: 'relatedProductsModal',
  SUBSTITUTE_PRODUCTS: 'substituteProducts',
  ALTERNATIVE_PRODUTS: 'alternativeProducts',
  VARIANTS: 'variants',
} as const;

export const ONLINE_VIEW = 'ONLINE_VIEW';
export const VIEW_ONLINE = 'VIEW_ONLINE';

export const rangeTabs = {
  [TAB_NAMES.Documents]: 'rangeDocuments',
  [TAB_NAMES.Presentation]: 'rangeOverview',
  [TAB_NAMES.Products]: 'rangeProducts',
  [TAB_NAMES.Software]: 'rangeUtilitiesAndFirmware',
  [TAB_NAMES.SoftwareRegistration]: 'rangeSoftwareRegistration',
  [TAB_NAMES.WebinarAndResources]: 'rangeWebinarAndResources',
} as const;
